import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';
import { TONE_CLASSES } from './pillTone';

/** "Technicien" pill (J16) — marks an actor whose account role is technician, next to their name
 * in the global table and the record's history timeline. */
const TechnicianPill = () => {
  const { t } = useTranslation();
  return <span className={cn('inline-flex h-[18px] items-center rounded-full px-2 text-[10.5px] font-medium', TONE_CLASSES.sky)}>{t('Technician')}</span>;
};

export default TechnicianPill;
